/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { Flags } from "react-feature-flags";
import SVG from "react-inlinesvg";
import { checkIsActive } from "../../../../_helpers";

import billsIcon from "../../../../../app/assets/images/icon-bills.svg";
import proposalsIcon from "../../../../../app/assets/images/icon-proposals.svg";
import organizationsIcon from "../../../../../app/assets/images/icon-organizations.svg";
import teamsIcon from "../../../../../app/assets/images/icon-teams.svg";
import userIcon from "../../../../../app/assets/images/user.svg";
import { FormattedMessage } from "react-intl";
import { useAuth } from "../../../../../utils/hooks/useAuth";
import PerSiteFormatedMessage from "../../../../../app/modules/Globals/components/PerSiteFormatedMessage";
import { features } from "../../../../../config/featureFlags";
import houseIcon from "../../../../../app/assets/images/house-svgrepo-com.svg";


export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${
          !hasSubmenu && "menu-item-active"
        } menu-item-open menu-item-not-hightlighted`
      : "";
  };

  const renderMenuItem = (link, icon, label, color = null) => {
    const url = `/${link}`;
    return (
      <li
        className={`menu-item ${getMenuItemActive(url, false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to={url}>
          <span className={`svg-icon menu-icon ${color != null ? color : ""}`}>
            <SVG src={icon} />
          </span>
          <span className="menu-text">{label}</span>
        </NavLink>
      </li>
    );
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <Flags
          authorizedFlags={[features.DISPLAY_CODE_CONTENT]}
          renderOn={() => (
            <>
              {renderMenuItem(
                "",
                houseIcon,
                <FormattedMessage id="HOME.LABEL" />
              )}
            </>
          )}
        />
        <Flags
          authorizedFlags={[features.DISPLAY_CODE_CONTENT]}
          renderOn={() =>
            renderMenuItem(
              "policyProposals",
              billsIcon,
              <PerSiteFormatedMessage id="POLICY_PROPOSAL" />
            )
          }
          renderOff={() =>
            renderMenuItem(
              "bills",
              billsIcon,
              <PerSiteFormatedMessage id="POLICY_PROPOSAL" />
            )
          }
        />
        <Flags
          authorizedFlags={[features.DISPLAY_CODE_CONTENT]}
          renderOn={() => (
            <>
              {renderMenuItem(
                "question-and-answer",
                proposalsIcon,
                <PerSiteFormatedMessage id="Q_A" />
              )}
              {renderMenuItem(
                "myProfile",
                userIcon,
                <FormattedMessage id="MY_PROFILE" />,
                "svg-icon-white"
              )}
            </>
          )}
        />
        {/*{renderMenuItem('teams', teamsIcon, 'Teams')}*/}
        {/*{renderMenuItem('settings', settingsIcon, 'Settings')}*/}
        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
